export default __webpack_public_path__ + "static/media/work-five.5daaa8ff.png";